export interface ServiceUrls {
  coreUrl: string;
  authorizationsUrl: string;
  coreRefreshUrl: string;
  userUrl: string;
  appointmentUrl: string;
  appointmentRoomsUrl: string;
  appointmentPlayGroupUrl: string;
  noteUrl: string; // Notlar için eklenebilir
  profileGroupUsersUrl: string; // Profil Grupları için eklenebilir
  profileGroupUrl: string; // Profil Grupları için eklenebilir
}

interface Endpoints {
  // Core Service
  authenticate: string;
  authorizations: string;
  refreshAuthentication: string;

  // User Service
  user: string;
  appointment: string;
  room: string;
  playGroup: string;
  note: string;
  profileGroupUsers: string;
  profileGroup: string;
}

interface ServiceAddress {
  coreService: string;
  userService: string;
  appointmentService: string;
  noteService?: string; // Notlar için eklenebilir
}

export const endpoints: Endpoints = {
  // Core Service
  authenticate: "authenticate",
  refreshAuthentication: "refresh-authentication",
  user: "user",
  appointment: "appointments",
  room: "room",
  playGroup: "playGroups",
  note: "notes", // Notlar için eklenebilir
  authorizations: "authorizations",
  profileGroupUsers: "profile-group-users",
  profileGroup: "profile-group",
} as const;

const ensureHttps = (url: string) => {
  if (typeof window !== "undefined" && window.location.protocol === "https:") {
    return url.replace("http://", "https://");
  }
  return url;
};

export const services: ServiceAddress = {
  coreService: ensureHttps(
    import.meta.env.VITE_CORE_SERVICE_URL ||
      `https://coreapi.hesapkitapp.com/api`,
  ),
  userService: ensureHttps(
    import.meta.env.VITE_USER_SERVICE_URL ||
      `https://userapi.hesapkitapp.com/api`,
  ),
  appointmentService: ensureHttps(
    import.meta.env.VITE_APPOINTMENT_SERVICE_URL ||
      `https://apoapi.hesapkitapp.com/api`,
  ),
  noteService: ensureHttps(
    import.meta.env.VITE_NOTE_SERVICE_URL ||
      `https://noteapi.hesapkitapp.com/api`,
  ),
} as const;

export const apiUrl: ServiceUrls = {
  // Core Service
  coreUrl: `${services.coreService}/${endpoints.authenticate}`,
  authorizationsUrl: `${services.coreService}/${endpoints.authorizations}`,
  coreRefreshUrl: `${services.coreService}/${endpoints.refreshAuthentication}`,
  userUrl: `${services.userService}/${endpoints.user}`,
  appointmentUrl: `${services.appointmentService}/${endpoints.appointment}`,
  appointmentRoomsUrl: `${services.appointmentService}/${endpoints.room}`,
  appointmentPlayGroupUrl: `${services.appointmentService}/${endpoints.playGroup}`,
  noteUrl: `${services.noteService}/${endpoints.note}`,
  profileGroupUrl: `${services.userService}/${endpoints.profileGroup}`,
  profileGroupUsersUrl: `${services.userService}/${endpoints.profileGroupUsers}`,
};

export function createRequestUrl(
  requestUrl: string,
  id?: string,
  subEndpoint?: string,
  subId?: string,
): string {
  return id && subEndpoint && subId
    ? `${requestUrl}/${id}/${subEndpoint}/${subId}`
    : id && subEndpoint
      ? `${requestUrl}/${id}/${subEndpoint}`
      : id
        ? `${requestUrl}/${id}`
        : requestUrl;
}
